var popup = function() {

  var items = document.querySelectorAll('.js--popup')
  var itemsBtn = document.querySelectorAll('.js--open-chat');

  itemsBtn.forEach(function (el) {
        el.addEventListener('click', function () {
            document.querySelector('body').classList.remove('body--popup')
            Intercom('show');
        })
    })

  items && items.forEach(el => {
    el.addEventListener('click', toggle)
  });

  function toggle(e) {
    if(typeof e !== 'undefined') e.preventDefault();

    if(document.body.classList.contains('body--popup')) {
      window.removeEventListener('keydown', closeModal)
      window.removeEventListener('click', closeModal)
      window.removeEventListener('touchstart', closeModal)
    } else {
      window.addEventListener('keydown', closeModal)
      window.addEventListener('click', closeModal)
      window.addEventListener('touchstart', closeModal)
    }

    document.body.classList.toggle('body--popup')
  }

  function closeModal(e) {

    if (e.keyCode == 27) {
      toggle();
    }
    if(e.target.className == 'popup' || e.target.className == 'popup__close') {
      toggle();
    }
  }


}


export default popup()
